import * as $ from 'jquery';
import { Dropdown } from 'bootstrap';
import { renderCaseHistory } from '../components/CaseHistory';

$(function() {
    const $sortSelect = $("#js-case-tracking-sort");

    const caseHistoryPanel = $('#js-caseHistory');
    if (caseHistoryPanel.length) {
        renderCaseHistory();
    }

    // Set case id on hash params when case is selected
    $('.js-toggleCaseHistory').on('click', function() {
       let caseId = $(this).data('id');
       location.replace(`#${caseId}`); 
    });

    // Close case tracking filters dropdown on outer click
    const caseTrackingFilters = $('#bs-caseTrackingFilters');
    if (caseTrackingFilters.length) {
        document.addEventListener('mousedown', function(e) {
            // Do nothing on dropdown button click
            if ($(e.target).is(caseTrackingFilters)) return;
            // Close dropdown on click if not on dropdown menu and date picker
            if (!$(e.target).closest('.dropdown-menu').length && !$(e.target).closest('.flatpickr-calendar').length) {
                var dropdown = Dropdown.getOrCreateInstance(caseTrackingFilters);
                dropdown.hide();
            }
        });
    }

    $('.js-multiple-select').select2({
        allowClear: true,
        multiple: true,
        width: '100%',
    });

    if ($sortSelect) {
        $sortSelect.on("change", function() {
            $(this).closest('form').trigger("submit");
        });
    }
});
